import React from "react";
import { useTranslation } from "react-i18next";
import {
  Panel,
  PanelTitle,
  Table,
  Td,
  Bodyrow,
  CountBadge,
  EmptyState,
  Scroll,
  SortLabel,
} from "./dashboardTable";

export const PopularGrips = ({
  title = "Popular Grips",
  dashboard_data,
  popularGripsSort,
  sortByType,
  sortBySize,
  sortByClients,
}) => {
  const { t } = useTranslation();

  const sortedData = dashboard_data.popular_grips.sort((a, b) => {
    if (popularGripsSort.type !== 0) {
      return popularGripsSort.type >= 0
        ? a.grip_type > b.grip_type
          ? 1
          : -1
        : a.grip_type > b.grip_type
        ? -1
        : 1;
    } else if (popularGripsSort.size !== 0) {
      return popularGripsSort.size >= 0
        ? a.size > b.size
          ? 1
          : -1
        : a.size > b.size
        ? -1
        : 1;
    } else if (popularGripsSort.clients !== 0) {
      return popularGripsSort.clients >= 0
        ? a.total * 1 > b.total * 1
          ? 1
          : -1
        : a.total * 1 > b.total * 1
        ? -1
        : 1;
    }
  });

  return (
    <Panel>
      <PanelTitle>{title}</PanelTitle>
      {sortedData.length === 0 ? (
        <EmptyState>{t("message.info.no_data", { defaultValue: "No data" })}</EmptyState>
      ) : (
        <Scroll>
          <Table>
            <thead>
              <tr>
                <SortLabel
                  label={t("general.type")}
                  sort={popularGripsSort.type}
                  onSort={sortByType}
                />
                <SortLabel
                  label={t("general.size")}
                  sort={popularGripsSort.size}
                  onSort={sortBySize}
                />
                <SortLabel
                  label={t("general.clients")}
                  sort={popularGripsSort.clients}
                  onSort={sortByClients}
                  align="right"
                />
              </tr>
            </thead>
            <tbody>
              {sortedData.map(({ grip_type, size, total }, idx) => (
                <Bodyrow key={idx}>
                  <Td>{grip_type}</Td>
                  <Td>{size}</Td>
                  <Td align="right">
                    <CountBadge>{total}</CountBadge>
                  </Td>
                </Bodyrow>
              ))}
            </tbody>
          </Table>
        </Scroll>
      )}
    </Panel>
  );
};
